import { useCallback, useState } from "react";
import {
  getStorageItem,
  localStorageSafe,
  sessionStorageSafe,
  setStorageItem
} from "../utils/storage/storage";
import { isDevelopment } from "../utils/assembly";

export const useStorage = (storage, key, initialValue, stringify) => {
  const [storedValue, setStoredValue] = useState(() => {
    return getStorageItem(storage, key, initialValue, stringify);
  });
  const setValue = useCallback(
    (value, stringify = false) => {
      let valueToStore;
      try {
        setStoredValue((valueOld) => {
          valueToStore = value instanceof Function ? value(valueOld) : value;
          setStorageItem(storage, key, valueToStore, stringify);
          return valueToStore;
        });
      } catch (error) {
        if (isDevelopment()) {
          console.log(
            "%c[Store] Error storing " + key,
            "background: red; color: white; font-size: 18px;",
            { key, value, valueToStore, error }
          );
        }
      }
    },
    [key, storage],
  );
  return [storedValue, setValue];
};

export const useLocalStorage = (key, initialValue, stringify) => {
  return useStorage(localStorageSafe, key, initialValue, stringify);
};

export const useSessionStorage = (key, initialValue, stringify) => {
  return useStorage(sessionStorageSafe, key, initialValue, stringify);
};
